import LayerIcon from "../../assets/icons/layers.svg";
import PlusIcon from "../../assets/images/Plus.svg";
import ReloadIcon from "../../assets/icons/Reload.svg";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import useScreenSize from "../../utils/hooks/useScreenSizeHook";
import "../../assets/styles/local/Stock.css";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

import {
  JITAdvicedItemPurchaseData,
  generateJITPurchaseOrder,
  fetchTranslationData,
} from "../../redux/actions/action";

const JustIntimePurchaseCard = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  const [JITPurchaseData, setJITPurchaseData] = useState([]);

  useEffect(() => {
    fetchScreenTranslations("Stock Overview").then(data => setFetchTranslationList(data));
  }, []);

  useEffect(() => {
    dispatch(JITAdvicedItemPurchaseData());
  }, []);

  const puchasingAdviceData = useSelector(
    (state) => state.user.JITAdvicedItemPurchase
  );

  useEffect(() => {
    if (puchasingAdviceData != null) {
      if (puchasingAdviceData?.status && puchasingAdviceData?.data) {
        setJITPurchaseData(puchasingAdviceData.data);
      }
    }
  }, [puchasingAdviceData]); 

  const formatNumber = (number) => {
    number = +number;
    return number ? number.toFixed(0).replace(/\d(?=(\d{3})+$)/g, "$&,") : 0;
  };

  const RedirectToPuchaseOrderPage = () => {
    history.push({
      pathname: "/just-in-time-purchasing",
    });
  };

  const GenerateJITPurchaseOrder = () => {
    generateJITPurchaseOrder().then((o) => {
      history.push({
        pathname: "/just-in-time-purchasing",
      });
    });
  };

  return (
    <>
      <div className="total-stock sub-stock sub-stock-jit minheight-42-vh mt-4 justinTimePurchasing">
        <div className="stock-title">
          <div className="d-flex justify-content-end totalStock-img">
            <img
              src={LayerIcon}
              className="stock-card-products-img"
              alt="totalStock"
            />
          </div>
          {/* <p className="stock-title-main">{"Just In Time Purchasing"}</p> */}
          <p className="stock-title-main">{t("Advised Item Purchasing")}</p>
          {JITPurchaseData.length > 0 && props.showActions && (
            <div className="d-flex totalStock-img">
              <img
                onClick={() => RedirectToPuchaseOrderPage()}
                src={PlusIcon}
                className="card-plus-img me-2"
                alt="totalStock"
              />
              {/* <img onClick={() => GenerateJITPurchaseOrder()}
                            src={ReloadIcon}
                            className="card-plus-img"
                            alt="totalStock"
                        /> */}
            </div>
          )}
        </div>
        <div className="sub-items">
          {JITPurchaseData.length > 0 && (
            <div className="row height-2vh ">
              <div className="col-5">
                <p className="adv-order-purchase-title">
                  &nbsp; <br />
                  {/* Item */}
                  {t("Item")}
                </p>
              </div>
              <div className="col-3 text-end">
                <p className="adv-order-purchase-title">
                  &nbsp; <br />
                  {/* Max */}
                  {t("Max")}
                </p>
              </div>
              <div className="col-4 text-end">
                <p className="adv-order-purchase-title">
                  {/* Purchase <br /> Qty */}
                  {t("Purchase")}
                  <br />
                  {t("Qty")}
                </p>
              </div>
            </div>
          )}
          <br />
          {JITPurchaseData.length > 0 &&
            JITPurchaseData.map((item, index) => (
              <div className="row height-2vh " key={index}>
                <div className="col-5">
                  <p className="adv-order-purchase-item">
                    {item.partname ? item.partname : ""}
                  </p>
                </div>
                <div className="col-3 text-end">
                  <p className="adv-order-purchase-item">
                    {formatNumber(item.max)}
                  </p>
                </div>
                <div className="col-4 text-end">
                  <p className="adv-order-purchase-item">
                    {formatNumber(item.purchaseQty)}
                  </p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default JustIntimePurchaseCard;
